export default {
    bySlug(slug) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .where('slug', slug)
                    .first()
            )
        );
    },

    bySection(section) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .where('section', section)
                    .first()
            )
        );
    },
}
